import React from 'react';
export function TopBar() {
  return <header className="flex items-center justify-between mb-8" data-id="element-132">
      <div data-id="element-133">
        <h1 className="text-2xl font-bold text-[#f0ead8] mb-1" data-id="element-134">Dashboard</h1>
        <p className="text-sm text-[#3a5070]" data-id="element-135">
          March 2026 · 4 active locations
        </p>
      </div>
      <div className="flex items-center gap-4" data-id="element-136">
        <button className="px-4 py-2 rounded-lg border border-[#0e1826] text-[#f0ead8] text-sm font-medium hover:bg-[#060c18] transition-colors" data-id="element-137">
          Export report
        </button>
        <button className="px-4 py-2 rounded-lg bg-[#060c18] border border-[#0e1826] text-[#f0ead8] text-sm font-medium hover:bg-[#0e1826] transition-colors flex items-center gap-2" data-id="element-138">
          <span data-id="element-139">+</span> New patient
        </button>
      </div>
    </header>;
}